import React from "react"
import { Card, Grid, Icon } from "semantic-ui-react"
import { formatCurrency } from "uikit"
import { NavLink } from "react-router-dom"

const ESHCPlanCard = ({
  id,
  name,
  type,
  label,
  ownerName,
  employerName,
  premium_amount,
  health_plan_coverage,
  is_hdhp,
  people_coverage
}) => (
  <Card>
    <Card.Content>
      <Grid style={{ position: "relative", height: "170px" }}>
        <Grid.Row columns={2} verticalAlign="top">
          <Grid.Column>
            <NavLink
              to={`/organize/income+benefits/benefits/${id}/${type.toLowerCase()}`}
              className="navlink"
            >
              <span className="GenericCard__LinkTitle">
                {label}
                <Icon name="chevron right" size="small" />
              </span>
              <p className="greyed-text">
                {employerName && `Sponsored by ${employerName}`}
              </p>
            </NavLink>
          </Grid.Column>
          <Grid.Column textAlign="right">
            <p className="GenericCard__Balance">
              {typeof premium_amount === "number"
                ? formatCurrency(premium_amount)
                : premium_amount}
            </p>
            <p className="greyed-text">{`${people_coverage[0].toUpperCase()}${people_coverage.substring(
              1
            )}`}</p>
          </Grid.Column>
        </Grid.Row>
        <Grid.Row columns={2} verticalAlign="bottom">
          <Grid.Column>
            <p className="greyed-text">{ownerName}</p>
          </Grid.Column>
          <Grid.Column textAlign="right">
            <p className="greyed-text">{is_hdhp ? "HDHP" : "Non-HDHP"}</p>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </Card.Content>
  </Card>
)

export default ESHCPlanCard
